export enum TrendLevel {
  None = 0,
  Lower = 1,
  Steady = 2,
  Higher = 3,
}
